import { useQuery } from '@apollo/client';
import { GET_BANNERS } from '../queries/banners';

export const useFetchBanners = () => {
  const { data, loading, error } = useQuery(GET_BANNERS);

  return {
    banners: data?.banners || [],
    loading,
    error,
  };
};
